<template>
  <div class="worldmap">
    <div class="header-area flex flex-nowrap items-center">
      <!-- <TourButton class="flex-none" @clicked="openTour(true)"></TourButton> -->
      <div v-if="$store.state.covid19.all['last_updated'] && $store.state.covid19.is_enabled" class="last-updated flex-auto text-sm">Updated {{ this.$store.state.covid19.all['last_updated'] }}</div>
    </div>

    <div class="viewmode-chart">

      <transition style="fade">
        <PreloaderOverlay v-if="$store.state.fetching.length"></PreloaderOverlay>
      </transition>

      <div
              :class="{
        'translate-top': !$store.state.covid19.is_enabled
        }"
              class="zoomnav hide-for-print">
        <div :class="{ isDisabled: (canZoomIn() === false) }" class="zoomnav__item zoomnav__item--in" @click.prevent="zoomIn()"><svg width="20" height="20" version="1.1" id="zoomIn" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><rect x="9.5" y="5" class="zoomnav__item__fill" width="1" height="10"/><rect x="5" y="10" class="zoomnav__item__fill" width="10" height="1"/></svg></div>
        <div :class="{ isDisabled: (canZoomOut() === false) }" class="zoomnav__item zoomnav__item--out" @click.prevent="zoomOut()"><svg width="20" height="20" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><rect x="5" y="10" class="zoomnav__item__fill" width="10" height="1"/></svg></div>
        <div :class="{ isDisabled: (canReset() === false) }" class="zoomnav__item zoomnav__item--reset" @click.prevent="zoomReset()"><svg width="20" height="20" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><g><g><rect x="2" y="3" class="zoomnav__item__fill" width="1" height="4"/><rect x="4" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 7 -2)" class="zoomnav__item__fill" width="1" height="5"/></g><g><rect x="14.5" y="0.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 17.5 -12.5)" class="zoomnav__item__fill" width="1" height="4"/><rect x="17" y="2" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 35 9)" class="zoomnav__item__fill" width="1" height="5"/></g><g><rect x="2" y="13" class="zoomnav__item__fill" width="1" height="4"/><rect x="4" y="15" transform="matrix(6.123234e-17 -1 1 6.123234e-17 -13 22)" class="zoomnav__item__fill" width="1" height="5"/></g><g><rect x="14.5" y="15.5" transform="matrix(6.123234e-17 -1 1 6.123234e-17 -2.5 32.5)" class="zoomnav__item__fill" width="1" height="4"/><rect x="17" y="13" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 35 31)" class="zoomnav__item__fill" width="1" height="5"/></g></g></svg></div>
      </div>

      <section class="maparea">
        <div id="worldmap" v-bind:style="{ height: mapHeight + 'px'}"></div>
      </section>

      <transition name="fade">
        <RegimeExplainer
                :class="'explainerstyle--bottom'"
                v-if="isRegimeEnabled"
        ></RegimeExplainer>
      </transition>

      <transition name="fade">
        <div
                :class="'explainerstyle--bottom'"
                v-if="!isRegimeEnabled"
        >
          <div class="text-bold mb-10 text-sm" v-if="$store.state.covid19.is_enabled">
            Pre-pandemic GSoD Indices 2019
          </div>
          <HighMediumLowExplainer :bg="false"></HighMediumLowExplainer>
        </div>
      </transition>

      <range-year-slider
              v-if="!$store.state.covid19.is_enabled"
              class="rangeSlider"
              :years="$store.state.defaultYears"
              :startSelection="$store.state.yearSliderCurrent"
      ></range-year-slider>
      <div class="bottom-push" v-if="$store.state.covid19.is_enabled"></div>
    </div>
  </div><!-- /.worldmap -->
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import SVG from 'svg.js'
  import svgPanZoom from 'svg-pan-zoom'
  import {EventBus} from '@/event-bus.js'
  import CountryRepository from './CountryRepository.js'

  import RegimeExplainer from '../shared/misc/RegimeExplainer'
  import HighMediumLowExplainer from '../shared/misc/HighMediumLowExplainer'
  import PreloaderOverlay from '../shared/misc/PreloaderOverlay'
  import HelpTooltip from '../shared/misc/HelpTooltip'
  import rangeYearSlider from '../shared/sliders/RangeYearSlider'
  import InfoOverlay from '../shared/misc/InfoOverlay'
  import TourButton from '../tour/tourButton'
  import { Covid19icons } from './../covid19/FrameworkWheelMixins.js'
  import Vue from 'vue'

  export default {
    name: 'worldmap',
    mixins: [ Covid19icons ],
    props: ['covidEnable'],
    components: { RegimeExplainer, TourButton, InfoOverlay, PreloaderOverlay, HelpTooltip, rangeYearSlider, HighMediumLowExplainer },
    data () {
      return {
        CancelToken: axios.CancelToken,
        countryDragTimer: false, // Counts the time a user clicks on a country
        cancel () {},
        canvas: false,
        countryGroup: false,
        countryRepository: new CountryRepository(),
        covid19group: false,
        currentGermanValue: {
          'German Democratic Republic': undefined,
          'Germany': undefined
        },
        currentZoom: 1,
        zoomScale: 1,
        data: [],
        mapSVGData: false,
        defaultZoom: 1,
        existingPattern: false,
        showConfidenceIntervals: true,
        showExplainer: false,
        tooltipDelay: 300,
        zoomSteps: [0.8, 1, 1.5, 3, 5],
        PanZoom: false,
        hoverDisabledCountries: ['N. Cyprus', 'Siachen Glacier', 'W. Sahara', 'Somaliland', 'Falkland Is.']
      }
    },
    mounted () {
      this.$root.showMaps = true
      this.$store.state.covid19.filter_available = true
      this.$store.state.regime_nav_enabled = true
      this.$store.state.covid19.is_enabled = this.covidEnable
      this.$store.state.viewMode = 'chart'
      EventBus.$emit('sidebar-nav', 'WorldMap')
      this.initMap()
    },
    destroyed () {
      EventBus.$emit('hidemap')
      EventBus.$emit('tooltip.hide')
      this.$root.showMaps = false
      this.$store.state.covid19.filter_available = false
      this.$store.state.regime_nav_enabled = false
      this.cancel()
      if (this.PanZoom) {
        delete this.PanZoom
      }
    },
    computed: {
      isRegimeEnabled () {
        return this.$store.state.regime_enabled && !this.selectedAttribute
      },
      viewmode () {
        return this.$store.state.viewMode
      },
      mapHeight () {
        let slider = document.getElementsByClassName('range-year-slider')[0]
        let sliderHeight = (slider && slider.clientHeight) ? slider.clientHeight : 0
        return this.contentSize.height - sliderHeight - 100 // add 100 margin
      },
      contentSize () {
        return this.$store.state.contentSize
      },
      windowSize () {
        return this.$store.state.windowSize
      },
      year () {
        return this.$store.state.yearSliderCurrent
      },
      regions () {
        let all = this.$store.state.rsc.all
        return all.regions
      },
      selectedAttribute () {
        return this.$store.getters['attributes/firstSelected']
      },
      selectedAttributeName () {
        if (!this.selectedAttribute) return false
        return this.$store.getters['attributes/labelInfo'](this.selectedAttribute, 'name')
      }
    },
    watch: {
      '$route' () {
        this.$store.state.covid19.is_enabled = this.covidEnable
      },
      '$store.state.covid19.is_enabled' () {
        this.assignDataToMap()
      },
      '$store.state.covid19.all' () {
        this.loadData()
      },
      '$store.state.yearSliderCurrent' () {
        this.loadData()
      },
      currentZoom () {
        if (this.PanZoom) {
          this.PanZoom.zoom(this.currentZoom)
        }
      },
      selectedAttribute () {
        this.assignDataToMap()
      },
      data () {
        // Populate the repository
        this.countryRepository.reset()
        for (let row of this.data) {
          let $el = this.canvas.select('[data-name="' + Vue.filter('fixedName')(row.ID_country_name) + '"]')
          if ($el) {
            this.countryRepository.addCountry(row, $el, this.$store)
          }
        }
        this.assignDataToMap()

        if (!this.selectedAttribute || this.selectedAttribute === undefined) {
          this.$nextTick(this.openTour)
        }
      },
      viewmode () {
        if (this.viewmode === 'table') {
          this.$store.state.covid19.filter_available = false
          let attr = this.selectedAttribute
          let query = {}
          if (attr) {
            query.attr = ['["' + attr + '"]']
          }
          this.$router.push({ name: 'world-map-table', query: query })
        } else {
          this.$store.state.covid19.filter_available = true
        }
      }
    },
    methods: {
      openTour (forceOpen) {
        EventBus.$emit('tour:open', 'map', forceOpen, [
          {
            title: this.$Strings('tour_map1_title'),
            content: this.$Strings('tour_map1_description'),
            elementId: false
          },
          {
            title: this.$Strings('tour_map2_title'),
            content: this.$Strings('tour_map2_description'),
            elementId: 'level-navigation'
          },
          {
            title: this.$Strings('tour_map3_title'),
            content: this.$Strings('tour_map3_description'),
            elementId: 'attribute-nav'
          },
          {
            title: this.$Strings('tour_map4_title'),
            content: this.$Strings('tour_map4_description'),
            elementId: 'range-year-slider'
          },
          {
            title: this.$Strings('tour_map5_title'),
            content: this.$Strings('tour_map5_description'),
            elementId: 'view-selector'
          }
        ])
      },
      documentHasMap () {
        if (!this.mapSVGData || document.getElementById('worldmap')) {
          return true
        }
      },
      initMap () {
        if (!this.documentHasMap()) { return false }

        this.canvas = SVG('worldmap')
        this.canvas.style({ width: '100%', height: '100%' })

        if (this.mapSVGData === false) {
          this.loadMap(() => {
            this.canvas.svg(this.mapSVGData)
            this.canvas.viewbox(-200, -20, 1005, 482)

            // Set all countries to disabled
            this.countryGroup = this.canvas.group()
            this.covid19group = this.canvas.group()

            let countries = this.canvas.select('[data-name]')
            countries.fill('#f1f3f7')

            // Add countries to group for easier access
            countries.each((i) => {
              this.countryGroup.add(countries.get(i))
            })

            this.canvas.attr('id', 'worldmap-svg')

            // Enable zoom
            this.enablePanZoom()

            // Remove areas without name from the map
            this.canvas.select('path:not([data-name])')
                    .fill('transparent')
                    .style('pointer-events', 'none')
                    .addClass('not-used')

            this.loadData()
          })
        } else {
          this.loadData()
        }
      },
      disablePanZoom () {
        if (this.PanZoom) {
          this.PanZoom.destroy()
          this.PanZoom = false
        }
      },
      enablePanZoom () {
        this.disablePanZoom()
        this.PanZoom = svgPanZoom('#worldmap-svg', {
          onPan: () => { this.$forceUpdate() },
          onZoom: (zoomScale) => {
            this.zoomScale = zoomScale
            this.$forceUpdate()
            this.assignDataToMap()
          }
        })
      },
      toggleInterval () {
        this.showConfidenceIntervals = !this.showConfidenceIntervals
      },
      loadMap (callback) {
        this.$store.dispatch('startFetching', 'map')
        this.cancel()
        axios.all([this.fetchMap()], {
          cancelToken: new this.CancelToken((c) => {
            this.cancel = c
          })
        })
                .then(axios.spread((response) => {
                  this.$store.dispatch('stopFetching', 'map')
                  this.mapSVGData = response.data.map
                  if (callback !== undefined) callback()
                }))
                .catch((error) => {
                  this.$store.dispatch('stopFetching', 'map')
                  if (!axios.isCancel(error)) {
                    EventBus.$emit('popup.open', this.$Strings('json_error_title'), this.$Strings('json_error_body'))
                  }
                })
      },
      loadData (callback) {
        this.$store.dispatch('startFetching', 'mapData')
        this.cancel()
        axios.all([this.fetchData()], {
          cancelToken: new this.CancelToken((c) => {
            this.cancel = c
          })
        })
                .then(axios.spread((response) => {
                  this.$store.dispatch('stopFetching', 'mapData')
                  this.data = response.data
                  if (callback !== undefined) callback()
                }))
                .catch((error) => {
                  this.$store.dispatch('stopFetching', 'mapData')
                  if (!axios.isCancel(error)) {
                    EventBus.$emit('popup.open', this.$Strings('json_error_title'), this.$Strings('json_error_body'))
                  }
                })
      },
      fetchData () {
        return axios.get(process.env.API_URL + 'data?year1=' + this.$store.state.yearSliderCurrent + '&year2=' + this.$store.state.yearSliderCurrent)
      },
      fetchMap () {
        return axios.get(process.env.API_URL + 'map')
      },
      getColor (name) {
        let color = _.find(this.$store.state.colors, { name: name })
        return color.hex
      },
      showCountryTooltip (country, attr) {
        if (country.name === 'Germany' || country.name === 'German Democratic Republic') {
          EventBus.$emit('tooltip.show', {
            style: 'germany',
            values: this.currentGermanValue
          })
        } else {
          EventBus.$emit('tooltip.show', {
            style: 'map',
            label: country.name,
            sublabel: country.regimeName(),
            value: country.attributeValue(attr)
          })
        }
      },
      showRegimeTooltip (country) {
        let regimeName = country.regimeName()
        if (regimeName) {
          EventBus.$emit('tooltip.show', {
            style: 'multiline',
            label: country.name,
            sublabel: regimeName
          })
        }
      },
      showCountryInfoTooltip (country) {
        let countryInfo = this.getCountryInfo(country)
        EventBus.$emit('tooltip.show', {
          style: 'country-info',
          label: country.name,
          value: countryInfo
        })
      },
      hideCountryTooltip () {
        EventBus.$emit('tooltip.hide')
      },
      resetCountries () {
        if (!this.countryGroup) return false
        this.resetCountryData()
      },
      resetCountryData (i) {
        for (const country of this.countryRepository.all()) {
          country.$el.stop()
                  .animate(1000, '>')
                  .fill(this.getColor('gray-light'))
          country.$el.off()
        }
      },
      addCovid19Icons () {
        let attr = this.selectedAttribute
        let countries = this.countryRepository.all()
        this.$store.dispatch('startFetching', 'mapCovid19Icons')

        for (let country of countries) {
          let iconsize = 12 / this.zoomScale // old value 17
          let type = attr ? country.countryAttributeType(attr) : country.incidentType()

          // There might no be any incidents
          // for a country in which case
          // we break the loop
          if (!type || type === '') continue

          // There might be more
          // than one area to
          // a country
          country.$el.each((i) => {
            // Fix for New Zealans that has two areas
            if (country.name === 'New Zealand' && i === 1) {
              return false
            }

            let icon = (type === 'watch') ? this.getDevelopmentsToWatchIcon(this.canvas, iconsize) : this.getConcerningDevelopmentsIcon(this.canvas, iconsize)
            let pos = country.$el.get(i).rbox(this.countryGroup)
            let x = pos.cx
            let y = pos.cy
            let offset = this.$store.state.covid19.countrymapIconOffset[country.name]

            if (offset && offset[i]) {
              x += offset[i].x ? offset[i].x : 0
              y += offset[i].y ? offset[i].y : 0
            }

            if (country.id === '830' || country.id === '210' || country.id === '220') {
              x = pos.x
              y = pos.y

              if (country.id === '220') {
                x = pos.x + 12
                y = pos.y + 11
              }
              if (country.id === '210') {
                x = pos.x + 2
                y = pos.y + 2
              }
            }
            if (country.id === '385') {
              x = pos.x + 5
              y = pos.y + (pos.height - 4)
            }
            if (country.id === '2') {
              x = pos.x + (pos.width / 3) + 9
              y = pos.y + 12
              icon.center(x, y)
              this.covid19group.add(icon)
              this.addCovid19IconTooltip(icon, country, type)

              icon = (type === 'watch') ? this.getDevelopmentsToWatchIcon(this.canvas, iconsize) : this.getConcerningDevelopmentsIcon(this.canvas, iconsize)

              x = pos.x2 - (pos.width / 3) - 7
              y = pos.y2 - (pos.height / 3) + 2
              icon.center(x, y)
              this.covid19group.add(icon)
              this.addCovid19IconTooltip(icon, country, type)

              return
            }
            if (country.id === '20') {
              x = pos.x + (pos.width / 3) - 6
              y = pos.y + (pos.height / 2) + 3
            }
            if (country.id === '155' || country.id === '235' || country.id === '212') {
              x = pos.x + 6
              y = pos.y + (pos.height / 2) + 3
            }

            if (country.id === '200') {
              x = pos.x + 6
              y = pos.y + 10
            }

            if (country.id === '560') {
              x += 1
              y += 10
            }
            icon.center(x, y)
            this.covid19group.add(icon)
            this.addCovid19IconTooltip(icon, country, type)
          })
        }

        this.$store.dispatch('stopFetching', 'mapCovid19Icons')
      },
      resetCovid19Icons () {
        if (this.covid19group) {
          this.covid19group.clear()
        }
      },
      addCovid19IconTooltip (icon, country, type) {
        icon.on('mouseover', () => {
          this.changeCountryFill(country, '#064c65')
          icon.style('cursor', 'pointer')
          EventBus.$emit('tooltip.show', {
            style: 'multiline',
            label: country.name,
            sublabel: country.regimeName(),
            value: [
              (type === 'watch' ? 'Developments to watch' : 'Concerning developments'),
              'Click for detailed information'
            ]
          })
        })

        icon.on('mousedown', () => { this.clickStart() })
        icon.on('mouseup', () => { this.clickEnd(country) })

        icon.on('mouseout', () => {
          this.changeCountryFill(country, '')
          EventBus.$emit('tooltip.hide')
        })
      },
      setCountryData () {
        let attr = this.selectedAttribute

        for (const country of this.countryRepository.all()) {
          if (['German Democratic Republic', 'Germany'].indexOf(country.name) !== -1 && this.hasBothGermanValues()) {
            country.$el
                    .stop()
                    .animate(1000, '>')
                    .fill(this.pattern(country.attributeColor(attr)))
          } else {
            country.$el
                    .stop()
                    .animate(1000, '>')
                    .fill(country.attributeHexColor(attr))
          }
        }

        this.applyTooltips()
      },
      getCountryInfo (country) {
        let infoMap = ['A_01', 'A_02', 'A_03', 'A_04', 'A_05']
        let countryInfo = []
        for (let key in infoMap) {
          let tkey = infoMap[key]
          if (!Number.isNaN(this.round(country.attributeValue(tkey)))) {
            countryInfo[key] = {
              'label': this.$store.getters['attributes/labelInfo'](tkey, 'name'),
              'value': this.round(country.attributeValue(tkey)).toFixed(2)
            }
          }
        }
        return countryInfo
      },
      round (num) {
        return Math.round(num * 100) / 100
      },
      changeCountryFill (country, color) {
        if (color === '') {
          let attr = this.selectedAttribute
          if (attr) {
            color = country.attributeHexColor(attr)
          } else {
            color = country.regimeHexColor()
          }
        }
        country.$el
                .stop()
                .style('cursor', 'pointer')
                .animate(1000, '>')
                .fill(color)
      },
      applyTooltips () {
        for (const country of this.countryRepository.all()) {
          if (this.hoverDisabledCountries.indexOf(country.name) === -1) {
            country.$el.off()
            country.$el.on('mouseover', () => {
              // This would either be an
              // attribute tooltip or
              // a regime tooltip
              this.changeCountryFill(country, '#064c65')
              this.showCountryInfoTooltip(country)
            })
            country.$el.on('mousedown', () => { this.clickStart() })
            country.$el.on('mouseup', () => { this.clickEnd(country) })
            country.$el.on('mouseout', () => {
              this.hideCountryTooltip()
              this.changeCountryFill(country, '')
            })
          }
        }
      },
      clickStart () {
        this.countryDragTimer = new Date()
      },
      clickEnd (country) {
        let end = new Date()
        let seconds = (end - this.countryDragTimer) / 1000.0

        if (seconds < 0.25) {
          let covidEnabled = this.$store.state.covid19.is_enabled ? '&covid19=1' : ''
          let pathRedirect = '/countries-regions-profile?rsc=[' + country.id + ']' + covidEnabled
          this.$router.push({ path: pathRedirect })
        }

        this.countryDragTimer = false
      },
      assignRegimeColors () {
        for (let country of this.countryRepository.all()) {
          country.$el
                  .stop()
                  .animate(1000, '>')
                  .fill(country.regimeHexColor())
        }

        this.applyTooltips()
      },
      assignDataToMap () {
        if (!this.documentHasMap()) { return false }

        this.$store.dispatch('startFetching', 'assignDataToMap')

        let year = this.$store.state.yearSliderCurrent
        let attributeIsSelected = !!this.selectedAttribute

        this.resetCovid19Icons()
        this.resetCountries()

        // Make sure all needed data is available
        // The user might need to select stuff - or data hasn't been
        // loaded yet
        if (!this.regions || !this.data || !year) {
          this.$store.dispatch('stopFetching', 'assignDataToMap')
          return false
        }

        this.setGermanValues()

        // Check for covid19 incident information and
        // display it if available
        if (this.$store.state.covid19.is_enabled) {
          this.addCovid19Icons()
        }

        if (!attributeIsSelected) {
          this.assignRegimeColors()
        } else {
          this.setCountryData()
        }

        this.$store.dispatch('stopFetching', 'assignDataToMap')
      },
      createStripedPattern (hex) {
        let size = 3
        return this.canvas.pattern(size, size, (add) => {
          add.rect(size, size).addClass('bg').fill(hex)

          add.line(0, size)
                  .addClass('stroke')
                  .fill(hex)
                  .stroke({ color: '#ffffff', width: 2, opacity: 0.5 })

          add.rotate(45)
        })
      },
      pattern (color) {
        if (!this.existingPattern) {
          this.existingPattern = this.createStripedPattern(this.getColor('gray-light'))
        }

        if (color !== undefined) {
          return this.createStripedPattern(this.getColor(color))
        }

        return this.existingPattern
      },
      setGermanValues () {
        let year = this.$store.state.yearSliderCurrent
        let attributeKey = this.selectedAttribute

        let Germany = _.find(this.data, (row) => {
          return parseInt(row.ID_year) === parseInt(year) && row.ID_country_name === 'Germany'
        })
        this.currentGermanValue['Germany'] = (Germany && Germany[attributeKey]) ? Germany[attributeKey] : undefined

        let GDR = _.find(this.data, (row) => {
          return parseInt(row.ID_year) === parseInt(year) && row.ID_country_name === 'German Democratic Republic'
        })
        this.currentGermanValue['German Democratic Republic'] = (GDR && GDR[attributeKey]) ? GDR[attributeKey] : undefined
      },
      hasBothGermanValues () {
        return this.currentGermanValue['Germany'] !== undefined &&
                this.currentGermanValue['German Democratic Republic'] !== undefined
      },
      canZoomIn () { return _.last(this.zoomSteps) !== this.currentZoom },
      canZoomOut () { return _.first(this.zoomSteps) !== this.currentZoom },
      canReset () {
        if ((this.PanZoom && this.PanZoom.getPan().x === 0) &&
                this.currentZoom === 1) {
          return false
        }
        return true
      },
      zoomOut () {
        if (this.canZoomOut()) {
          let index = this.zoomSteps.indexOf(this.currentZoom)
          this.currentZoom = this.zoomSteps[index - 1]
        }
      },
      zoomIn () {
        if (this.canZoomIn()) {
          let index = this.zoomSteps.indexOf(this.currentZoom)
          this.currentZoom = this.zoomSteps[index + 1]
        }
      },
      zoomReset () {
        if (this.canReset()) {
          this.currentZoom = 1
          this.PanZoom.reset()
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/mixins/clearfix';
  @import '~@/components/sass/mixins/flexbox-grid';

  .maparea{
    position: relative;
  }

  #worldmap{
    cursor: move;
    height: 500px;
    width: 100%;
  }

  #worldmap svg path {
    stroke: white;
    stroke-width: 0.2;
  }

  .mapexplainer {
    bottom: 0;
    color: $gray-darkest;
    display: flex; -js-display: flex;
    flex-wrap: nowrap;
    position: absolute;
    right: 40px;

    &__svg{
      margin: 5px 5px 0 0;
      flex: 1 1 10px;
      height: 128px;
      width: 10px;
    }
    &__values{
      flex: 1 1 auto;
    }

    &__values__help{
      margin-bottom: -2px;
    }

    ul{
      display: flex; -js-display: flex;
      flex-direction: column;
      font-size: 10px;
      height: 150px;
      line-height: 1;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li{
      flex: 1 1 auto;
      margin: 0;
      padding: 0;
    }
  }

  .worldmap {
    position: relative;
    //overflow: hidden;
  }

  .zoomnav{
    font-size: 0;
    line-height: 0;
    position: absolute;
    right: 20px;
    top: 15px;
    white-space: nowrap;
    z-index: 10;
    &.translate-top{
      top: -55px;
    }
  }
  .zoomnav__item{
    background: $gray-lightest;
    cursor: pointer;
    display: inline-block;
    padding: 5px;

    .zoomnav__item__fill{
      fill: $gray-darkest;
    }
    &:not(.isDisabled):hover {
      background: $gray-lighter;
    }

    &.isDisabled{
      cursor: auto;
      .zoomnav__item__fill{ fill: $gray-light; }
    }
  }
  .zoomnav__item--out{ border-left: 1px solid $gray-light; }
  .zoomnav__item--reset{ margin-left: 20px; }

  .header-area {
    position: absolute;
    left: 20px;
    top: 20px;
  }

  .bottom-push {
    background: url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7); // Transparent
    pointer-events: none;
    display: block;
    height: 50px;
    width: 100%;
  }

  .explainerstyle--bottom {
    position: absolute;
    bottom: 105px;
    left: 65px;
  }

  .explainerstyle--top {
    position: absolute;
    top: 22px;
    left: 65px;
  }


</style>



// WEBPACK FOOTER //
// src/components/pages/Map.vue